import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { SentryWrapper } from '@cimpress-technology/ui-reporting-helpers';
export const Sentry = ({ sentryOptions, selector }) => {
    const { profile } = useSelector(selector) || {};
    const shouldEnable = () => {
        if (!sentryOptions.enabled) {
            return false;
        }
        const currentUrl = window.location.toString();
        let enabled = true;
        (sentryOptions.blacklistUrls || [])
            .forEach((blacklistUrl) => {
            if (currentUrl.indexOf(blacklistUrl) === 0) {
                enabled = false;
            }
        });
        return enabled;
    };
    useEffect(() => {
        if (shouldEnable()) {
            const directSentryOptions = {
                releaseVersion: sentryOptions.releaseVersion,
                dsn: sentryOptions.dsn,
                scope: sentryOptions.scope,
            };
            SentryWrapper.initSentry(directSentryOptions);
        }
    }, [sentryOptions]);
    useEffect(() => {
        if (shouldEnable()) {
            if (profile && profile.user_id) {
                SentryWrapper.updateProfile(profile);
            }
        }
    }, [profile]);
    return null;
};
//# sourceMappingURL=Sentry.js.map